import { Injectable, inject } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';
import { Capacitor } from '@capacitor/core';
import { DataLayerService } from '../datalayer/datalayer.service';
import { PAGE } from 'src/app/routes';
import { WalletId } from 'src/app/model/wallet/wallet-types';
import { UserStateService } from 'src/app/core/services/user-state/user-state.service';

export enum ClinchCampaignState {
  None,
  StartMatchmakingTier,
  Pay,
}

@Injectable({
  providedIn: 'root',
})
export class PopupCampaignService {
  private dataLayerService = inject(DataLayerService);
  private userStateService = inject(UserStateService);
  private platform = inject(Platform);

  private isSigningIn = false;
  private clinchCampaignState = ClinchCampaignState.None;

  aboutToSignIn() {
    this.isSigningIn = true;
  }

  setClinchCampaignState(state: ClinchCampaignState) {
    this.clinchCampaignState = state;
  }

  leaveSiteDetected(pageName: string) {
    if (this.isMobileWeb() || this.isNativePlatform()) {
      return;
    }
    this.handleSiteAbandoned(pageName);
  }

  navButtonClicked(pageName: string) {
    if (!this.isMobileWeb() || this.isNativePlatform()) {
      return;
    }
    this.handleSiteAbandoned(pageName);
  }

  headerBackButtonClicked(pageName: string) {
    this.handleSiteAbandoned(pageName);
  }

  clinchMatchmakingClosed(pageName: string) {
    this.handleSiteAbandoned(pageName);
  }

  private handleSiteAbandoned(pageName: string) {
    if (!this.userStateService.onboarded) {
      if (pageName === `/${PAGE.SIGNIN}` && !this.isSigningIn) {
        // Don't emit this event if the user is in the process of signing in
        this.dataLayerService.emitOnSiteExitEvent('sign_in_exit_event_pt_br');
      } else if (pageName === `/${PAGE.ACCOUNT}`) {
        this.dataLayerService.emitOnSiteExitEvent('nickname_exit_event_pt_br');
      } else if (pageName === `/${PAGE.SELECT_WALLET}`) {
        this.dataLayerService.emitOnSiteExitEvent('select_wallet_exit_event_pt_br');
      } else if (pageName === `/${PAGE.LINK_WALLET}/${WalletId.Alby}`) {
        this.dataLayerService.emitOnSiteExitEvent('link_wallet_alby_exit_event_pt_br');
      } else if (pageName === `/${PAGE.LINK_WALLET}/${WalletId.WalletOfSatoshi}`) {
        this.dataLayerService.emitOnSiteExitEvent('link_wallet_wos_exit_event_pt_br');
      } else if (pageName === `/${PAGE.LINK_WALLET}/${WalletId.ZBD}`) {
        this.dataLayerService.emitOnSiteExitEvent('link_wallet_zbd_exit_event_pt_br');
      }
      return;
    }

    if (this.clinchCampaignState === ClinchCampaignState.StartMatchmakingTier) {
      this.dataLayerService.emitOnSiteExitEvent('join_clinch_exit_event_pt_br');
    } else if (this.clinchCampaignState === ClinchCampaignState.Pay) {
      this.dataLayerService.emitOnSiteExitEvent('pay_invoice_exit_event_pt_br');
    }
  }

  private isMobileWeb(): boolean {
    return this.platform.is('mobile') || this.platform.is('mobileweb') || this.platform.is('pwa');
  }

  private isNativePlatform(): boolean {
    return Capacitor.isNativePlatform();
  }
}
